import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  appVersion: string = '1.0.0';

  constructor(
    public translate: TranslateService,
    public languageService: LanguageService
  ) {}

  ngOnInit(): void {
    // Initialisation si nécessaire
  }
}
